import officeBWLogo from '@/components/PlatformIcon/icons/office-bw.png';
import officeLogo from '@/components/PlatformIcon/icons/office.png';
import { PlatformTypes } from '@/types/gql.generated';
import { useAlwaysAvailable } from './availability.lib';
import type { DestinationModule } from './types';

export const officeLinkDestination: DestinationModule = {
  platform: PlatformTypes.OfficeLink,
  behavior: 'copy',
  name: 'Office 365',
  shortName: 'Office',
  addLabel: 'Add to Office 365',
  syncKind: 'copy',
  icon: { kind: 'image', src: officeLogo, bwSrc: officeBWLogo },
  isPinnable: true,
  persistedByServer: false,
  statusSource: 'localOnly',
  useIsAvailable: useAlwaysAvailable,
  weblink: { urlKey: 'office' },
};
